import React from 'react';
import { useSelector } from 'react-redux';
import { CellInfo } from 'react-table';

import { ViewFrame, ListTable } from '../../components';
import { useActionDispatcher, useTitle } from '../../hooks';
import DeleteAction from '../../components/action/DeleteAction';
import AdvancedActionCell from '../../components/action-cell/AdvancedActionCell';
import {
  deletePromotionCodeRequest,
  getPromotionCodeListRequest,
  setPromotionCodeListDirty,
} from '../../store/modules/promotion-codes/actions';
import { selectPromotionCodeList } from '../../store/modules/promotion-codes/selectors';

const title = 'Promotion Codes';

const PromotionCodeList = () => {
  useTitle(title);

  const { loading, data, dirty } = useSelector(selectPromotionCodeList);

  const getList = useActionDispatcher(getPromotionCodeListRequest);
  const setDirty = useActionDispatcher(setPromotionCodeListDirty);
  const deletePromotionCode = useActionDispatcher(deletePromotionCodeRequest);

  return (
    <ViewFrame title={title}>
      <ListTable
        columns={[
          {
            id: 'code',
            Header: 'Code',
          },
          {
            id: 'ref.created_age',
            Header: 'Created',
          },
          {
            id: 'ref.updated_age',
            Header: 'Updated',
          },
          {
            id: 'ref.organization.common_name',
            Header: 'Organization',
          },
          {
            id: 'ref.user.full_name_first_last',
            Header: 'Referrer',
            width: 130,
          },
          {
            id: 'actions',
            accessor: 'id',
            Cell: (cell: CellInfo) => (
              <AdvancedActionCell>
                {
                  cell.original.permissions.can_delete
                  && <DeleteAction {...cell} onDelete={deletePromotionCode} />
                }
              </AdvancedActionCell>
            ),
            width: 65,
          },
        ]}
        loading={loading}
        data={data}
        fetch={getList}
        dirty={Boolean(dirty)}
        setDirty={setDirty}
      />
    </ViewFrame>
  );
};

export default PromotionCodeList;
